import { SchoolContentSectionType } from '@axl/accel-framework/models';
import Api from 'api';
import { SchoolContentItemFavorite, SchoolContentItemFavoriteFilter } from 'models';

export type CreateFavoriteModel = {
    sectionType: SchoolContentSectionType;
    courseItemId?: string;
    libraryItemId?: string;
}

export default class FavoriteApi {
    constructor(private api: Api) {
    }

    fetch = async (filter: SchoolContentItemFavoriteFilter) => {
        return await this.api.getList<SchoolContentItemFavorite, SchoolContentItemFavoriteFilter>('/school-content-item-favorite',
            '',
            filter,
            (json: any) => {
                return {
                    items: json.items.map(SchoolContentItemFavorite.fromJson),
                    filter: new SchoolContentItemFavoriteFilter(json.filter)
                }
            });
    }

    create = async (model: CreateFavoriteModel) => {
        return await this.api.post<SchoolContentItemFavorite>('/school-content-item-favorite',
            model,
            (json: any) => SchoolContentItemFavorite.fromJson(json));
    }

    delete = async (id: string) => {
        return await this.api.delete(`/school-content-item-favorite/${id}`);
    }
}
